/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-2",
    "aws_cognito_identity_pool_id": "ap-northeast-2:6f9c5051-5b36-474f-adba-03b289f4f6a6",
    "aws_cognito_region": "ap-northeast-2",
    "aws_user_pools_id": "ap-northeast-2_ncBB9e3uu",
    "aws_user_pools_web_client_id": "obopb3ne613jemtbul1k323vv",
    "oauth": {
        "domain": "howhana-prod.auth.ap-northeast-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://howhana.howcs.kr/",
        "redirectSignOut": "https://howhana.howcs.kr/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "6",
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://qsg6k5b5df.execute-api.ap-northeast-2.amazonaws.com/prod",
            "region": "ap-northeast-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2ynz66dfrjcl3hcrz7w5hnpnl4.appsync-api.ap-northeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "howhana15623-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-2",
    "aws_content_delivery_bucket": "howhana-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "ap-northeast-2",
    "aws_content_delivery_url": "https://d1gdl5pwrh73hv.cloudfront.net"
};


export default awsmobile;
